"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var elog = require("@reverbdotcom/commons/dist/elog");
var react_apollo_1 = require("react-apollo");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var threeds2_interaction_1 = require("../credit_cards/threeds2/threeds2_interaction");
var threeds2_billing_operations_1 = require("./threeds2_billing_operations");
var bind_1 = require("../bind");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
var loading_bars_1 = require("../components/loading_bars");
function BillingTitle(_a) {
    var title = _a.title;
    if (!title) {
        return null;
    }
    return (React.createElement("div", { className: "form-section-wrapper__header" },
        React.createElement("h2", { className: "form-section-wrapper__title" }, title)));
}
var TAG = 'adyen.threeds2_billing_container';
var ThreeDS2BillingContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeDS2BillingContainer, _super);
    function ThreeDS2BillingContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ThreeDS2BillingContainer.prototype, "paymentStatus", {
        get: function () {
            return this.props.billingMethodResult.adyenPaymentResult.paymentStatus;
        },
        enumerable: true,
        configurable: true
    });
    ThreeDS2BillingContainer.prototype.eventData = function (additionalContext) {
        if (additionalContext === void 0) { additionalContext = {}; }
        return {
            componentName: 'ThreeDS2BillingContainer',
            context: tslib_1.__assign(tslib_1.__assign({}, additionalContext), { props: tslib_1.__assign({}, this.props) }),
        };
    };
    ThreeDS2BillingContainer.prototype.componentDidMount = function () {
        tracker_1.trackView(this.eventData());
        elog.info(TAG + ".mount", tslib_1.__assign({}, this.eventData()));
    };
    ThreeDS2BillingContainer.prototype.onIdentifyShopperComplete = function (fingerprintResult) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.identifyShopper({ variables: { input: {
                                        billingMethodUuid: this.props.billingMethodResult.billingMethodUuid,
                                        results: {
                                            paymentData: this.props.billingMethodResult.adyenPaymentResult.paymentData,
                                            threeds2FingerprintResult: fingerprintResult,
                                        },
                                    } } })];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onBillingMethodResult(result.data.billingMethodIdentifyShopper);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        this.onThreeDSFailed(parse_graphql_errors_1.parseGraphqlErrors(error_1));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ThreeDS2BillingContainer.prototype.onChallengeShopperComplete = function (challengeResult) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.challengeShopper({ variables: { input: {
                                        billingMethodUuid: this.props.billingMethodResult.billingMethodUuid,
                                        results: {
                                            paymentData: this.props.billingMethodResult.adyenPaymentResult.paymentData,
                                            threeds2ChallengeResult: challengeResult,
                                        },
                                    } } })];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.props.onBillingMethodResult(result.data.billingMethodChallengeShopper);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        this.onThreeDSFailed(parse_graphql_errors_1.parseGraphqlErrors(error_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ThreeDS2BillingContainer.prototype.onThreeDSFailed = function (errors) {
        elog.info(TAG + ".failed", {
            errors: errors,
            paymentStatus: this.paymentStatus,
        });
        this.props.onError(errors);
    };
    ThreeDS2BillingContainer.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(BillingTitle, { title: this.props.title }),
            React.createElement("div", { className: "bg-white padding-4" },
                React.createElement("div", { className: "d-flex fx-justify-center mtb-1" },
                    React.createElement(loading_bars_1.default, null)),
                React.createElement(threeds2_interaction_1.default, { challengeToken: this.props.billingMethodResult.adyenPaymentResult.challengeToken, fingerprintToken: this.props.billingMethodResult.adyenPaymentResult.fingerprintToken, onChallengeShopperComplete: this.onChallengeShopperComplete, onIdentifyShopperComplete: this.onIdentifyShopperComplete, paymentStatus: this.paymentStatus }))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2BillingContainer.prototype, "onIdentifyShopperComplete", null);
    tslib_1.__decorate([
        bind_1.default
    ], ThreeDS2BillingContainer.prototype, "onChallengeShopperComplete", null);
    return ThreeDS2BillingContainer;
}(React.Component));
exports.ThreeDS2BillingContainer = ThreeDS2BillingContainer;
exports.default = react_apollo_1.compose(threeds2_billing_operations_1.connectBillingMethodIdentifyShopper, threeds2_billing_operations_1.connectBillingMethodChallengeShopper)(ThreeDS2BillingContainer);
//# sourceMappingURL=threeds2_billing_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/billing/threeds2_billing_container.js
// module id = Eg5J
// module chunks = 20 21